<div class="wrapper">
    <div class="status-list">
        <div *ngFor="let status of statuses$|async"
            class="status"
            [class.selected]="isStatusGroupSelected(status)"
            (click)="selectStatusGroup(status)">
            {{status.name}}
        </div>
    </div>

    <div class="order-lines-wrapper search-scrolled-view">
        <div  *ngIf="(isLoading$ | async)"class="spinner-wrapper">
            <mat-spinner
                [diameter]="25"></mat-spinner>
        </div>
        <app-empty-result *ngIf="!(isLoading$ | async) && (hasEmptyResult$|async)"></app-empty-result>

        <ng-container *ngIf="!(isLoading$ | async) && !(hasEmptyResult$|async)">
            <div class="order-lines-item-wrapper"
                *ngFor="let group of orderLineGroups$ | async">
                <div *ngIf="group.items.length">
                    <div class="order-lines-header">{{group.name}}</div>
                    <div class="order-lines-card-wrapper">
                        <div class="order-lines-card"
                            *ngFor="let orderLine of group.items">
                            <div class="order-card-header"
                                *ngIf="orderLine?.publicId">
                                ORD-{{orderLine.publicId}}/{{orderLine.lineId}}</div>
                            <div class="order-card-customer">{{orderLine.contactFirstname}}
                                {{orderLine.contactSurname}}</div>
                            <div
                                class="order-card-product">{{orderLine.productName}}</div>
                            <div class="order-card-price-label">
                                <span *ngIf="orderLine?.totalPrice">
                                    {{orderLine.gross | currency:'GBP'}}
                                </span>
                            </div>
                            <div class="label-wrapper">
                                <div class="order-label"
                                    *ngFor="let label of orderLine.labels"
                                    [style.backgroundColor]="label.colour">
                                </div>
                            </div>
                            <div *ngIf="orderLine?.orderId?.length"
                                class="order-card-view-order"><a
                                    (click)="goToOrder(orderLine)">View order</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
